import { ChassisType, ChassisModelTypes, ChassisSeriesTypes, ChassisPassengerCapacities } from "../../../../../@types/ChassisType";
import assets from "../../../../../assets";

// E4 Specific Products
import { 
    ChassisBatteryConfigs, 
    ChassisBatteryConfigsPreassembly 
} from "./E4Products/ChassisBatteryConfigs";
import Tops from "./E4Products/Tops";

// Shared Products between ESeries Chassis
import BodyColorsE4 from "../Shared/BodyColors";
import { LiftKitsE4 } from "../Shared/LiftKit";
import Batteries from "../Shared/Batteries";
import { 
    Wheels12In, 
    Wheels12InLifted, 
    WheelSizeOptions 
} from "../Shared/Wheels";
import LugNuts from "../../Shared/LugNuts";
import { Tires12In, Tires12InLifted } from "../Shared/Tires";
import { LsvKit, LsvKitPreassembled } from "../Shared/LsvKit";
import { FrontSeats, RearSeats } from "../Shared/Seats";
import SeatFrames from "../Shared/SeatFrames";
import { AccessoriesESeries, AccessoriesESeriesLifted, AccessoriesESeriesOptional, AccessoriesESeriesOptionalNonLifted } from "../../Shared/Accessories";
import WindShields from "../Shared/Windshields";

export const E4: ChassisType = {
    id: `${ChassisModelTypes.E4}-2024`,
    sku: `${ChassisModelTypes.E4}-2024`,
    series: ChassisSeriesTypes.ESeries,
    categoryName: 'ESeries',
    name: `2024 ESeries E4 4 Passenger`,
    year: 2024,
    model: ChassisModelTypes.E4,
    logo: assets.images.chassisLogo.e4,
    passengerCapacity: ChassisPassengerCapacities["4 Passenger"],
    price: 5365,
    retailPrice: 8995,
    marketingSlogan: 
    `More Thrills. Less Bills`,
    bodyColorOptions: BodyColorsE4,
    liftKitOptions: LiftKitsE4,
    chassisBatteryConfigOptions: ChassisBatteryConfigs,
    chassisBatteryOptions: Batteries,
    wheelSizeOptions: WheelSizeOptions,
    wheelOptions: Wheels12In,
    wheelOptionsLifted: Wheels12InLifted,
    lugNutOptions: LugNuts,
    tireOptions: Tires12In,
    tireOptionsLifted: Tires12InLifted,
    lsvKitOptions: LsvKit,
    topOptions: Tops,
    windshieldOptions: WindShields,
    frontSeatOptions: FrontSeats,
    rearSeatOptions: RearSeats,
    seatFrameOptions: SeatFrames,
    preassembled: false,
    allowInternationalPurchase: true,
    includedAccessories: AccessoriesESeries,
    includedAccessoriesLifted: AccessoriesESeriesLifted,
    optionalAccessories: [...AccessoriesESeriesOptional, ...AccessoriesESeriesOptionalNonLifted],
    optionalAccessoriesLifted: AccessoriesESeriesOptional
}

export const E4Assy: ChassisType = {
    ...E4,
    id: `${ChassisModelTypes.E4}-2024-Assy`,
    sku: `${ChassisModelTypes.E4}-2024-Assy`,
    price: 5665,
    preassembled: true,
    allowInternationalPurchase: false,
    lsvKitOptions: LsvKitPreassembled,
    chassisBatteryConfigOptions: ChassisBatteryConfigsPreassembly
}